
import dbGateway from '@/api/dbGateway';

const model = {
  
  getBudgetOrgList(param = {}) {
    return dbGateway.post('/bs-client/bs/sys/budgetOrg/list', param);
  },

  
  saveBudgetOrg(param = {}) {
    if (param.id) {
      return dbGateway.post('/sys/budgetOrg/modify', param);
    }
    return dbGateway.post('/sys/budgetOrg/create', param);
  },

  
  getBudgetOrgById(param = {}) {
    return dbGateway.get(`/sys/budgetOrg/${param.id}`);
  },

  
  deleteBudgetOrgById(param = {}) {
    return dbGateway.post('/sys/budgetOrg/remove', param);
  },

  
  syncBudgetOrg(param = {}) {
    return dbGateway.post('/sys/budgetOrg/syncBudgetOrg', param);
  },
};

export default model;
